/* eslint-disable */ 
import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Servicio from '@/components/Servicio'
import Mapa from '@/components/Mapa'
import Mensajero from '@/components/Mensajero'
import Mensajeros from '@/components/Mensajeros'
import UserMap from '@/components/UserMap'
import Servicios from '@/components/Servicios'
import Metrics from '@/components/Metrics'
import Eficiencia from '@/components/Eficiencia'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/tracking/:id',
      name: 'Servicio',
      component: Servicio,
      props: (route) => ({ query: [route.query.nav, route.query.adm] }) 
    },
    {
      path: '/servicios/:id',
      name: 'Servicios',
      component: Servicios
    },
    {
      path: '/map/:id',
      name: 'Mapa',
      component: Mapa
    },
    {
      path: '/mensajero/:id',
      name: 'Mensajero',
      component: Mensajero,
      props: (route) => ({ query: [route.query.inicio, route.query.fin] })
    },
    {
      path: '/mensajeros',
      name: 'Mensajeros',
      component: Mensajeros
    },
    {
      path: '/user/:id',
      name: 'Mensajeros',
      component: UserMap
    },
    {
      path: '/mapa-clientes',
      name: 'Metrics',
      component: Metrics
    },
    {
      path: '/eficiencia',
      name: 'Eficiencia',
      component: Eficiencia
    }
/*     {
      path: "*",
      redirect: '/'
    } */
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js